import React from 'react'
import {RiGithubFill,RiSunFill,RiMoonFill} from 'react-icons/ri'
import './style.css';

function Header() {
  return (
    <div className='header'>
        <span className='header-logo'>AUI</span>
        <div className='header-right'>
            <span className='header-icons'><RiGithubFill /></span>
            <span className='header-icons'><RiSunFill /></span>
        </div>        
    </div>
  )
}

export default Header